
import { Component, Vue } from "vue-property-decorator";
import NameAndCedula from "@/components/person/NameAndCedula.vue";
import ValidationService from "@/services/ValidationService";
import User from "../models/User";
import ValidacionCertificacionTss from "@/models/ValidacionCertificacionTss";
import { Getter } from "vuex-class";
import { AxiosResponse } from "axios";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import RequisitoBeneficio, {
  Requisito,
  ParametrosValidacionRequisitosBeneficio,
} from "@/models/RequisitoBeneficio";
import TipoRequisitoEnum from "@/enums/TipoRequisitoEnum";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import Swal from "sweetalert2";
import AfiliadoService from "@/services/AfiliadoService";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import Presolicitud from "@/models/Presolicitud";
import { formatFechaAfpSiembra } from "@/utils/HelperFunctions";
import ParamsGetSolicitud from "@/models/ParamsGetSolicitud";
import SolicitudBeneficio from "@/models/SolicitudBeneficio";
import ServiceResponseArchivos from "@/services/response-models/ServiceResponseArchivos";
import DocumentoPresolicitud from "@/models/DocumentoPresolicitud";
import IngresoTardioService from "@/services/IngresoTardioService";
import IframeCommunicatorService, {
  InterPagesMessages,
  MessageTypes,
} from "@/services/IframeCommunicatorService";
import GlobalConfig from "@/GlobalConfig";

@Component({
  components: {
    NameAndCedula,
  },
})
export default class ResumenIT extends Vue {
  @Getter("user") user: User;
  public loading: boolean = false;
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public ingresoTardioService = new IngresoTardioService();
  public currentPresolicitud: Presolicitud = null;
  public currentSolicitud: SolicitudBeneficio = null;
  public documentosCurrentPresolicitud: DocumentoPresolicitud[] = [];
  public tipoDocumentos: Requisito[] = [];
  public nombresTiposDocs: string[] = [];
  public iframeCommunicator = new IframeCommunicatorService();
  public showResumenIt = false;

  get montoFormatted() {
    return this.currentSolicitud && this.currentSolicitud.montoResumen
      ? this.currentSolicitud.montoResumen.toLocaleString("en-US", {
          minimumFractionDigits: 2,
        })
      : "";
  }
  public created() {}

  public mounted(): void {
    var alalal = this.$route;
    var packageParameter = this.$route.query.packageId
      ? this.$route.query.packageId
      : this.$route.query.package;
    if (packageParameter) {
      this.showLoadingAlert("Cargando...");
      this.loading = true;
      let path: string = null;
      let query: any = {};
      const packageId: string = String(packageParameter);
      const packageStatus: string = String(this.$route.query.status);
      this.afiliadoService
        .getPresolicitud(
          new ParametrosObtencionPresolicitud(null, null, null, packageId)
        )
        .then(async (response: AxiosResponse<ServiceResponseSolicitudes>) => {
          if (
            response.data.solicitudes &&
            response.data.solicitudes.length > 0
          ) {
            // The first one must be the record we are looking for
            this.currentPresolicitud = response.data.solicitudes[0];
            query = { packageId: packageId };
            switch (this.currentPresolicitud.tipoBeneficio) {
              case TipoBeneficioEnum.Cesantia + "":
                path = "/resumen-solicitud-cesantia";
                this.$router.push({
                  path: path,
                  query: query,
                });
                return;
              case TipoBeneficioEnum.VejezAnticipada + "":
                path = "/resumen-solicitud-vejez-anticipada";
                this.$router.push({
                  path: path,
                  query: query,
                });
                return;
              default:
                this.showResumenIt = true;
                break;
            }

            let promise1 = this.getDatosSolicitud(
              this.currentPresolicitud.numeroSolicitud
            );
            let promise2 = this.getDocumentosSolicitud(
              this.currentPresolicitud.numeroSolicitud
            );
            Promise.all([promise1, promise2]).finally(() => {
              Swal.close();
            });

            //Send to encuesta
            if (!this.currentPresolicitud.encuestaCompletada) {
              //The encuesta page needs to load from scratch so dont use vue router.
              // this.$router.push({
              //     path: "/encuesta",
              //     query: {
              //             tipoBeneficio: this.currentPresolicitud.tipoBeneficio,
              //             numeroSolicitud: this.currentPresolicitud.numeroSolicitud+""
              //         }
              // });
              window.location.href = `encuesta?tipoBeneficio=${this.currentPresolicitud.tipoBeneficio}&numeroSolicitud=${this.currentPresolicitud.numeroSolicitud}&redirectTo=${this.$route.fullPath}`;
              return;
            }
          }
          console.log("no hay solicitud");
        })
        .catch(() => {
          Swal.close();
        })
        .finally(() => {
          this.loading = false;
        });
      //
    } else {
      this.navigateToSolicitudes();
    }
  }

  public getDatosSolicitud(numeroSolicitud: number) {
    let promise = this.afiliadoService.getSolicitud(
      new ParamsGetSolicitud(TipoBeneficioEnum.IngresoTardio, numeroSolicitud)
    );
    promise.then((response) => {
      if (response.data.respCode == 200) {
        this.currentSolicitud = response.data.entity;
      }
    });

    return promise;
  }

  public getDocumentosSolicitud(numeroSolicitud: number) {
    let promise = this.ingresoTardioService.documentosRequeridos("");
    promise.then((response) => {
      this.tipoDocumentos = response.data.entities;
      this.afiliadoService
        .getDocumentosPresolicitud(numeroSolicitud)
        .then((response: AxiosResponse<ServiceResponseArchivos>) => {
          this.documentosCurrentPresolicitud = response.data.archivos;
          this.getPresolicitudDocumentName();
        });
    });

    return promise;
  }

  public getPresolicitudDocumentName() {
    let listOfTipoDocumentoId = this.documentosCurrentPresolicitud.map((x) => {
      return x.tipoDocumento;
    });
    let tipoDocs = this.tipoDocumentos.filter((x) => {
      return listOfTipoDocumentoId.indexOf(x.codRequisito.toString()) > -1;
    });

    this.nombresTiposDocs = tipoDocs.map((x) => {
      return x.descripcion;
    });
  }

  public navigateToSolicitudes(): void {
    this.$router.push("/solicitudes-beneficiario");
  }

  public formatDate(dateString: string) {
    return formatFechaAfpSiembra(dateString);
  }

  public showErrorAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "error",
      allowOutsideClick: true,
      showConfirmButton: true,
      confirmButtonText: "Ok",
    });
  }
  public showLoadingAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
  }
}
